import { UPDATE_SELECTED_PAYMENT_OPTION, UPDATE_EMI_CARD_PAYMENT_OPTION } from 'actions/PaymentActions/PaymentActions';

export const INITIAL_STATE = {
	mainOption: '',
	emiCard: ''
};

export default function selectedPaymentOption(state = INITIAL_STATE, action = {}) {
	switch (action.type) {
		case UPDATE_SELECTED_PAYMENT_OPTION:
			return Object.assign({}, state, { mainOption: action.data });
		case UPDATE_EMI_CARD_PAYMENT_OPTION:
			return Object.assign({}, state, { emiCard: action.data });
		default:
			return state;
	}
}
